import { Box, Button, Typography } from '@mui/material'
import CardTAG from '../../CardTAG'
import { IResetPasswordSuccessForm } from './types'
import successIcon from '../../../assets/images/successIcon.svg'

const SetPasswordSuccessForm: React.FC<IResetPasswordSuccessForm> = ({ navigateToLogin }) => {
  return (
    <CardTAG title='Your password has been updated!'>
      <Box
        sx={{ display: 'flex', justifyContent: 'center', width: '100%', marginBottom: '2.8rem' }}
      >
        <img src={successIcon} width='50px' height='50px' />
      </Box>
      <Typography variant='bodyRegular' align='left'>
        Your password has been successfully updated.
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '18px', width: '100%' }}>
        <Button variant='submitFormButton' type='submit' onClick={navigateToLogin}>
          <Typography variant='bodyBold'>Back To Log In</Typography>
        </Button>
      </Box>
    </CardTAG>
  )
}

export default SetPasswordSuccessForm
